import GitLabBackend from './implementation';
import API from './API';
import AuthenticationPage from './AuthenticationPage';

export const NetlifyCmsBackendGitlab = {
  GitLabBackend,
  API,
  AuthenticationPage,
};
export { GitLabBackend, API, AuthenticationPage };
